import React, { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import axios from "../../../../api/axios";

import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { FormGroup, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";

import AddIcon from "@mui/icons-material/Add";
import ContentCopy from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import Stack from "@mui/material/Stack";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import "./admin_acgtcards.css";

import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import { useLocation } from "react-router-dom";
import { url } from "../../../../configlink";

//import ACGTCardPaymentViewDlg from "./ACGTCardPaymentViewDlg";

export default function ACGTCardTransactionHistoryEdit() {
  let [changedData, setChangedData] = useState({});

  let [data, setData] = useState({
    trDate: "",
    trFullName: "",
    trType: "",
    trAmount: "",
    trSubTotal: "",
  });

  let loc = useLocation();

  useEffect(() => {
    let trId = loc.search.split("=")[3];
    let cardId = loc.search.split("=")[2].split("&")[0];
    let userId = loc.search.split("=")[1].split("&")[0];
    console.log(trId);
    console.log(userId);
    console.log(cardId);

    getTransactionHistory(trId, userId, cardId);
  }, []);

  async function getTransactionHistory(trId, userId, cardId) {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_acgt_transaction_detail`,
        {
          params: {
            trId: trId,
            userId: userId,
            cardId: cardId,
          },
          withCredentials: true,
        }
      );
      console.log(response.data);
      if (response.data) {
        let dataObject = response.data;
        setData({
          ...data,
          trDate: dataObject.spdate,
          trFullName: dataObject.FullName,
          trType: dataObject.stype,
          trAmount: dataObject.Amount.split("$ ")[1],
          trSubTotal: dataObject.SubTotal,
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  function updateContent() {
    console.log("update");
  }

  return (
    <div>
      <div>
        <div>
          <div className="p-2">
            <h1 className="text-2xl font-bold ">Transaction Details</h1>
            <div className="border border-black p-2 text-[13px] flex flex-col gap-[5px]">
              <div className="flex py-1 px-2">
                <p className="min-w-[250px]">Date</p>
                <input
                  type="text"
                  className="border border-black px-2  w-[250px]"
                  value={data.trDate}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      trDate: e.target.value,
                    });
                    setData({ ...data, trDate: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 bg-gray-100">
                <p className="min-w-[250px]">Full Name</p>
                <input
                  type="text"
                  className="border border-black px-2  w-[250px]"
                  value={data.trFullName}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      trFullName: e.target.value,
                    });
                    setData({ ...data, trFullName: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 ">
                <p className="min-w-[250px]">Type</p>
                <input
                  type="text"
                  className="border border-black px-2  w-[250px]"
                  value={data.trType}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      trType: e.target.value,
                    });
                    setData({ ...data, trType: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 bg-gray-100">
                <p className="min-w-[250px]">Amount</p>
                <input
                  type="text"
                  className="border border-black px-2  w-[250px]"
                  value={data.trAmount}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      trAmount: e.target.value,
                    });
                    setData({ ...data, trAmount: e.target.value });
                  }}
                />
              </div>

              <div className="flex justify-center mt-8 text-[14px]">
                <button
                  onClick={() => updateContent()}
                  className="bg-[var(--color-primary-purple)] text-white border border-black px-2"
                >
                  {" "}
                  Update Transaction
                </button>
              </div>
            </div>

            <div className="flex justify-center mt-8 text-[14px]">
              <button
                onClick={() => window.close()}
                className="bg-[var(--color-primary-purple)] text-white border border-black px-2"
              >
                {" "}
                Close Window
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
